import {barChartSvg as Icon__small__barChartSvg} from '../Icon__small/Icon__small--barChart.js';
import {barChartSvg as Icon__xsmall__barChartSvg} from '../Icon__xsmall/Icon__xsmall--barChart.js';

export var barChart = {
  name: 'barChart',
  category: 'icon',
  colorable: true,
  svg: Icon__small__barChartSvg,
  alt: {
    Icon__small: Icon__small__barChartSvg,
    Icon__xsmall: Icon__xsmall__barChartSvg,
  },
  combined: ['Icon__small', 'Icon__xsmall'],
};
